/* ================================================== */
/* CHECK IOS
/* ================================================== */

function checkIos() {

	if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
		$('html').attr('data-device', 'ios');
		return true;
	}

}